module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-15.f2e812fe.png";